<admin-page-simple-content
  [pageError]="pageError"
  [pageStatus]="pageStatus"
  [title]="(mode === 'create' ? 'Create' : 'Edit') + ' Session Photo Source'"
  [icon]="'perm_identity'"
  >
  @if (pageStatus === PageStatus.loaded) {
    <div class="content">
      <section class="edit-form">
        <div class="title">
          <h2 class="mat-h2">
            <p>Session Photo Source</p>
          </h2>
        </div>
        <p>
          Photo source id: <code>{{ photoSourceId }}</code>
        </p>
        <p>
          You can find more information about the following fields in the
          <a href="https://doc.mediaclip.ca/hub/photo-sources/session-photos/" target="_blank">documentation</a>
        </p>
        <form (ngSubmit)="save()" #form="ngForm">
          <section class="section-config">
            <h2 class="mat-h2">Configuration</h2>
              <div>
                  <admin-translatable-label-field
                      label="Label"
                      [(value)]="labelValue"
                      [locales]="supportedLocales()"
                      [(translations)]="labelTranslations"
                  />
              </div>
            <div class="thumbnail">
              <mat-form-field>
                <mat-label>Thumbnail URL</mat-label>
                <input
                  matInput
                  id="editSessionPhotoSourceThumbnailUrl"
                  autocomplete="off"
                  name="thumbnailUrl"
                  type="text"
                  required
                  [formControl]="thumbnailUrlControl"
                  />
                  <button type="button"
                          matIconButton
                          matSuffix
                          (click)="thumbnailFileUploader.click()">
                      <mat-icon>upload</mat-icon>
                  </button>
                @if (thumbnailUrlControl.invalid) {
                  <mat-error>Required</mat-error>
                }
              </mat-form-field>
              <input #thumbnailFileUploader type="file" style="display: none;" (change)="onThumbnailSelected(thumbnailFileUploader.files)" />
                @if (thumbnailUrlControl.valid) {
                <img alt="" [src]="thumbnailUrlControl.value" />
              }
            </div>
            <mat-checkbox
              id="editSessionPhotoSourceEnabled"
              name="enabled"
              [checked]="enabledControl.value"
              (change)="enabledControl.setValue($event.checked)"
              >Enabled
            </mat-checkbox>
          </section>
          <admin-save-button [disabled]="form.invalid || !photoSourceIdControl.valid || !thumbnailUrlControl.valid"
            [pageStatus]="pageStatus">Save
          </admin-save-button>
        </form>
        <div>
          @if (pageError) {
            <admin-error [error]="pageError"></admin-error>
          }
        </div>
      </section>
    </div>
  } @else if (pageStatus === PageStatus.loading) {
    Loading...
  } @else if (pageStatus === PageStatus.loadError) {
    <admin-error [error]="pageError"></admin-error>
  }
</admin-page-simple-content>
